import React, { useEffect } from 'react';
import Segments from './Segments';
import Descriptions from './descriptions/Descriptions';
import MealPlans from './MealPlans';
import KidPolicies from './KidPolicies';
import {
    usePropertyComplementaryData,
    usePropertyFetching,
    usePropertyProgress,
} from '../../../contextsProperty/ContextProperties';
import useLanguage from '../../../../customHooks/useLanguage';
import ImagesList from '../images/ImagesList';
import DescriptionServices from './DescriptionServices';

const Description = () => {
    const { language } = useLanguage();
    const { activeTab } = usePropertyProgress();
    const { handleFetching } = usePropertyFetching();
    const { getDescriptionSectionData } = usePropertyComplementaryData();

    useEffect(() => {
        const getData = async () => {
            handleFetching(true);
            await getDescriptionSectionData();
            handleFetching(false);
        };
        getData();
    }, [language]);

    const getCurrentForm = () => {
        switch (activeTab) {
            case 1:
            default:
                return <KidPolicies />;
            case 2:
                return <Segments />;
            case 3:
                return <DescriptionServices />;
            case 4:
                return <MealPlans />;
            case 5:
                return <Descriptions />;
            case 6:
                return <ImagesList />;
        }
    };

    return <>{getCurrentForm()}</>;
};

export default Description;
